// extracted by mini-css-extract-plugin
export default {"container":"CategoryPage_container__4yI6c","row":"CategoryPage_row__p5RK-"};